import axios from '../axios';

// 操作日志列表
export const getSysLogPage = data => {
return axios({
url: '/api/sys/sys/getSysLogPage',
method: 'post',
data
})
};

// 操作日志保存
export const saveSysLog = data => {
return axios({
url: '/api/sys/sys/saveSysLog',
method: 'post',
data
})
};

// 操作日志修改
export const updateSysLog = data => {
return axios({
url: '/api/sys/sys/updateSysLog',
method: 'post',
data
})
};

// 操作日志删除
export const deleteSysLog = data => {
return axios({
url: '/api/sys/deleteSysLog',
method: 'post',
data
})
};

// 操作日志查单条
export const getSysLog = data => {
return axios({
url: '/api/sys/getSysLog',
method: 'post',
data
})
};




// WEBPACK FOOTER //
// ./src/api/moudules/SysLogApi.js